// True when the user asked the OS/browser for reduced motion. Guards JS-driven
// feedback (canvas/matter-js) that the global CSS collapse in style.css cannot
// stop — a rAF loop is not a CSS transition. Falls back to false where
// matchMedia is unavailable (older jsdom test envs) so behaviour is unchanged.
export const prefersReducedMotion = (): boolean=> {
  if (
    typeof window === "undefined" ||
    typeof window.matchMedia !== "function"
  ) {
    return false
  }
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}